/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 */
import React from 'react';
import { CustomTextField } from '../../../../components/CustomTextField';
import CustomDateTimePicker from '../../../../components/CustomDateTimePicker';

/**
 * Third step of the invite external user modal, the logged resident picks the
 * range the visitor can enter on and writes the instructions of the visit.
 *
 * @param {Object} props
 * @param {Function} props.t - Localization function.
 * @param {boolean} props.emptyFields - Marks the required fields left empty.
 * @param {Object} props.invitation - Form of the invitation being created.
 * @param {Function} props.handleChange - Updates the field the resident is filling.
 */
const InviteExternalUserStep3 = ({ t, emptyFields, invitation, handleChange }) => {

    return (
        <div className={'row'}>
            <div className={'col-12'}>
                <p className={'font-color-general-950 fs-14px text-center'}>
                    {t('provide_the_required_information_to_create_and_send_the_visitor_invitation')}
                </p>

                <p className={'font-color-general-950 ibl-font-w-600 fs-14px text-center my-4 text-uppercase'}>
                    {t('choose_the_period_of_the_visit')}
                </p>
            </div>

            <div className={'col-sm-12 col-md-6'}>
                <CustomDateTimePicker
                    id={'dp_ieu_start_date_at_time'}
                    name={'startDateAtTime'}
                    disabled={false}
                    onChange={(value) => {
                        handleChange({ target: { value, name: 'startDateAtTime' } });
                    }}
                    trans={'start_date_at_time'}
                    value={invitation?.startDateAtTime}
                    required={true}
                    disablePast={true}
                    emptyFields={emptyFields}
                    maxDateTime={invitation?.endDateAtTime ? new Date(invitation.endDateAtTime) : undefined}
                />
            </div>

            <div className={'col-sm-12 col-md-6'}>
                <CustomDateTimePicker
                    id={'dp_ieu_end_date_at_time'}
                    name={'endDateAtTime'}
                    disabled={false}
                    onChange={(value) => {
                        handleChange({ target: { value, name: 'endDateAtTime' } });
                    }}
                    trans={'end_date_at_time'}
                    value={invitation?.endDateAtTime}
                    required={true}
                    disablePast={true}
                    emptyFields={emptyFields}
                    minDateTime={invitation?.startDateAtTime ? new Date(invitation.startDateAtTime) : undefined}
                />
            </div>

            <div className={'col-12'}>
                <p className={'font-color-general-950 ibl-font-w-600 fs-14px text-center my-4 text-uppercase'}>
                    {t('add_the_instructions_of_the_visit')}
                </p>
            </div>

            <div className={'col-12'}>
                <CustomTextField
                    id={'txt_ieu_instruction'}
                    length={512}
                    name={'instructions'}
                    value={invitation?.instructions}
                    trans={'instructions'}
                    type={'text'}
                    disabled={false}
                    onChange={handleChange}
                    required={false}
                    emptyFields={false}
                    multiline={true}
                />
            </div>
        </div>
    );
};

export default InviteExternalUserStep3;
